import { Link, useLocation } from "@tanstack/react-router";

import { css, cx } from "../../styled-system/css";

export type LinkGroupProperties = {
  className?: string;
  links: ReadonlyArray<{ available: boolean; label: string; path: string }>;
};
export function LinkGroup({ className, links }: LinkGroupProperties) {
  const location = useLocation();

  return (
    <div
      className={cx(
        css({
          backgroundColor: "muted-background",
          borderRadius: "6px",
          display: "flex",
          padding: "4px",
          width: "max-content",
        }),
        className,
      )}
    >
      {links
        .filter(({ available }) => available)
        .map(function ({ label, path }, index) {
          return (
            <Link
              className={css({
                borderRadius: "2px",
                display: "block",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                paddingX: "12px",
                paddingY: "6px",
                _selected: {
                  backgroundColor: "background",
                },
              })}
              data-selected={location.pathname.startsWith(path) ? true : undefined}
              key={index}
              to={path}
            >
              {label}
            </Link>
          );
        })}
    </div>
  );
}
